<app-menu-toggle
  tooltip="Browse geometry"
  icon="top-cube"
  [active]="browseDetectorParts"
  (click)="toggleOverlay()"
>
</app-menu-toggle>
